import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingState } from '../../components/common/EmptyState';
import { toast } from 'sonner';

export const AuthCallback = () => {
  const { processGoogleSession, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Get session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Error de autenticación: No se recibió sesión');
        navigate('/login');
        return;
      }

      try {
        const userData = await processGoogleSession(sessionId);
        toast.success(`Bienvenido, ${userData.nombre}`);

        // Redirect based on role
        if (userData.rol === 'propietario') {
          navigate('/propietario', { replace: true, state: { user: userData } });
        } else if (userData.rol === 'analista') {
          navigate('/analista/edificios', { replace: true, state: { user: userData } });
        } else if (userData.rol === 'admin') {
          navigate('/admin/edificios', { replace: true, state: { user: userData } });
        } else {
          navigate('/', { replace: true, state: { user: userData } });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        toast.error('Error al procesar la autenticación');
        navigate('/login');
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <LoadingState message="Procesando autenticación..." />
    </div>
  );
};

export default AuthCallback;
